


















































import { Component, Vue } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { WidgetState } from '@/store/widget/types';

@Component
export default class AppHeader extends Vue {
  @Getter('widget/logo') logo!: string;
  @State('widget') widget!: WidgetState;
}
